
export enum Gender {
    Male = 'Male',
    Female = 'Female',
}

// TODO: add all 52
